// extracted by mini-css-extract-plugin
export default {"root":"ScrollMenu_root__ykLml","hidden":"ScrollMenu_hidden__4OKuR"};